import React from "react";

import Button from "../../../common/components/Button/Button";
import Context from "../../../context/Context";
import {
  ModalController,
  WorkingController,
} from "../../../common/components/Modal";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";
import * as mergeUtil from "../../base/mergeUtil";

import { CalciteP } from "calcite-react/Elements";

import {
  ContentWrapper,
  HeaderContainer,
  Header,
  ContentContainer
} from "../../styles/backstageStyles";

export default class MergePlan extends React.Component {

  constructor(props){
    super(props);
    this.state = component.newState({
      isWorking: true,
      noDiff: false,
      wasMerged: false,
    });
  }

  componentDidMount() {
    this.checkDifferences();
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  checkDifferences = () => {
    this.setState({ isWorking: true });
    const project = Context.instance.spaceplanner.planner.project;
    const versionManager = project.versionedInfo.versionManager;
    const options = {
      plan: Context.instance.spaceplanner.activePlan
    };
    versionManager.hasDifferences(options).then(result => {
      let hasDiff = result && result.hasDifferences;
      this.setState({
        isWorking: false,
        noDiff: !hasDiff
      });
    }).catch(ex => {
      //this.setState({ isWorking: false });
      console.error("Error checking differences", ex);
      Topic.publishErrorAccessingData();
    });
  }

  mergeClicked = () => {
    if (this.state.isWorking) return;
    this.setState({ isWorking: true });

    const i18n = Context.instance.i18n;
    const workingController = new WorkingController();
    const workingContent = i18n.spaceplanner.backstage.mergePlan.mergingPlan;
    workingController.show({}, workingContent);

    const project = Context.instance.spaceplanner.planner.project;
    const versionManager = project.versionedInfo.versionManager;
    const plan = Context.instance.spaceplanner.activePlan;
    const options = {
      plan: plan,
      versionManager: versionManager,
      reconcile: true,
      applyEdits: true,
      post: true
    };
    //options.post = false;

    mergeUtil.analyze(options).then(task => {
      //console.log("MergePlan mergeUtil::analyze",task)
      workingController.close();
      this.setState({
        isWorking: false,
        wasMerged: !!task.wasMerged
      });
    }).catch(ex => {
      let submessage = ex.submessage || ex.message;
      workingController.close();
      ModalController.alert({
        isError: true,
        title: i18n.spaceplanner.backstage.mergePlan.errorMergingTitle,
        message: i18n.spaceplanner.backstage.mergePlan.errorMergingMessage,
        submessage: submessage
      });
      this.setState({ isWorking: false });
      console.error("Error merging plan", ex);
    });
  }

  // mergeClicked = () => {
  //   if (this.state.isWorking) return;
  //   this.setState({ isWorking: true });
  //
  //   const i18n = Context.instance.i18n;
  //   const workingController = new WorkingController();
  //   const workingContent = i18n.spaceplanner.backstage.mergePlan.mergingPlan;
  //   workingController.show({}, workingContent);
  //
  //   const project = Context.instance.spaceplanner.planner.project;
  //   const versionManager = project.versionedInfo.versionManager;
  //   const options = {
  //     plan: Context.instance.spaceplanner.activePlan
  //   };
  //
  //   versionManager.mergePlan(options).then(task => {
  //     workingController.close();
  //     this.setState({
  //       isWorking: false,
  //       wasMerged: task.wasMerged
  //     });
  //   }).catch(ex => {
  //     let submessage = ex.submessage || ex.message;
  //     workingController.close();
  //     ModalController.alert({
  //       isError: true,
  //       title: i18n.spaceplanner.backstage.mergePlan.errorMergingTitle,
  //       message: i18n.spaceplanner.backstage.mergePlan.errorMergingMessage,
  //       submessage: submessage
  //     });
  //     this.setState({ isWorking: false });
  //     console.error("Error merging plan", ex);
  //   });
  // }

  render() {
    const i18n = Context.instance.i18n;
    return (
      <ContentWrapper>
        <HeaderContainer>
          <Header>{i18n.spaceplanner.backstage.mergePlan.caption}</Header>
        </HeaderContainer>
        <ContentContainer>
          {this.renderContent()}
        </ContentContainer>
      </ContentWrapper>
    )
  }

  renderContent() {
    const {isWorking, noDiff, wasMerged} = this.state;
    const i18n = Context.instance.i18n;
    let msg = i18n.spaceplanner.backstage.mergePlan.prompt;
    if (noDiff) {
      msg = i18n.spaceplanner.backstage.mergePlan.noDiff;
    } else if (wasMerged) {
      msg = i18n.spaceplanner.backstage.mergePlan.merged;
    }
    return (
      <div>
        <CalciteP>
          {msg}
        </CalciteP>
        <Button
          disabled={isWorking || noDiff || wasMerged}
          onClick={this.mergeClicked}>
          {i18n.spaceplanner.backstage.mergePlan.label}
        </Button>
      </div>
    );
  }

}
